import * as filestack from 'filestack-js';
import * as fileUpload from 'blueimp-file-upload/js/jquery.fileupload.js';
import Spinner from 'src/javascripts/components/utilities/Spinner';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';

// Pick an image and update an associated attribute in DB
export default function(accepted_file_types = null) {
  const accountUrl = $('body').attr('data-account-url');

  // Select an image on click
  const selectImageContainer = function() {

    $(".uploaded-image-container").click(function() {

      // Toggle active classes
      $('.uploaded-image-container.active').not($(this)).removeClass('active');
      $(this).toggleClass('active');

      // If active, enable submit button
      if ($(this).hasClass('active')) {
        $('.select-image').prop('disabled', false)
        $('.select-image').attr('data-title', '')
      } else {
        $('.select-image').prop('disabled', true)
        $('.select-image').attr('data-title', 'Select an image')
      }

    });

  }
  selectImageContainer();

  // Remove an image
  $('.remove-uploaded-image').click(function() {
    $(this).closest('.form-group').find('input[type=\'hidden\']').val('');
    $(this).closest('.form-group').find('img').attr('src','');
  });

  // Set environment and account id for AWS path vars
  $('.filepicker').each(function(i, elem) {
    let fileInput    	= $(elem);
	  let env 					= fileInput.data("env");
    let firmId        = fileInput.data("firm-id");
    let firmUrl       = fileInput.data("firm-url");
    let isAdmin       = fileInput.data("is-admin");
    let recordId      = fileInput.data("record-id");
    let scope         = fileInput.data("scope");
    let backPath      = fileInput.data("back-path");
    var progressBar  	= $("<div class='bar'></div>");
    var barContainer 	= $("<div class='progress' style=\'height: 0px;\'></div>").append(progressBar);
    $('#imageUploadProgress').append(barContainer);
    fileInput.fileupload({
      fileInput:       	fileInput,
      url:             	fileInput.data('url'),
      type:            	'POST',
      autoUpload:       true,
      formData:         fileInput.data('form-data'),
      paramName:        'file', // S3 does not like nested name fields i.e. name="user[avatar_url]"
      dataType:         'XML',  // S3 returns XML if success_action_status is set to 201
      replaceFileInput: false,
      progressall: function (e, data) {
        var progress = parseInt(data.loaded / data.total * 100, 10);
        progressBar.css('width', progress + '%')
      },
      start: function (e) {
        progressBar.
          css('background', '#8c81d1').
          css('display', 'block').
          css('width', '0%').
          text("Loading...");
        barContainer.css('height', '35px');
      },
      done: function(e, data) {
        progressBar.text("Uploading done");

        $('.modal-body').css('opacity', 0.3);
        Spinner($('.modal-content'));

        // extract key from response
        let key = $(data.jqXHR.responseXML).find("Key").text();
        let ext = key.split(".").pop().toLowerCase();
        if ((typeof accepted_file_types !== 'undefined') && (accepted_file_types !== null)) {
          let inArr = jQuery.inArray(ext, accepted_file_types);
          if (inArr === -1) {
            ToastCustom({title: 'File type not allowed', message: 'Please select from the allowed file types', delay: 5000});
            $('.modal-body').css('opacity', 1);
            $('.modal-content').find('.spinner-container').remove();
            progressBar.css('width', '0%')
            progressBar.
              css('background', 'transparent').
              css('display', 'none').
              css('width', '0%').
              text("");
            barContainer.css('height', '0px');
            return;
          }
        }

        // Create image in local DB
        let updateUrl;
        let formData;
        if (isAdmin === true) {
          updateUrl = '/admin/images';
          formData = {'image': {'url': key, 'admin': true, 'image_type': 'admin'}};
        } else {
          updateUrl = '/' + accountUrl + '/images';
          formData = {'account_image': {'url': key, 'image_type': scope}};
        }

	      // Update local attribute
        return $.ajax({
	        type: 'POST',
	        url: updateUrl,
	        dataType: "script",
	        data: formData
	      });

      },
      fail: function(e, data) {
        progressBar.
          css("background", "red").
          text("Failed");
      }
    });
  });

}

